import type { Component } from 'vue';
import Select from './Select.vue';

export default new Map<string, Component>([
  ['Select', Select],
]);

